module.exports = __webpack_public_path__ + "img/friosImage.1fa946eb.svg";